"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.HistoricalEventToJSON = exports.HistoricalEventFromJSONTyped = exports.HistoricalEventFromJSON = exports.instanceOfHistoricalEvent = void 0;
var runtime_1 = require("../runtime");
var EventType_1 = require("./EventType");
/**
 * Check if a given object implements the HistoricalEvent interface.
 */
function instanceOfHistoricalEvent(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfHistoricalEvent = instanceOfHistoricalEvent;
function HistoricalEventFromJSON(json) {
    return HistoricalEventFromJSONTyped(json, false);
}
exports.HistoricalEventFromJSON = HistoricalEventFromJSON;
function HistoricalEventFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'type': !(0, runtime_1.exists)(json, 'type') ? undefined : (0, EventType_1.EventTypeFromJSON)(json['type']),
        'hourPartition': !(0, runtime_1.exists)(json, 'hour_partition') ? undefined : (new Date(json['hour_partition'])),
        'count': !(0, runtime_1.exists)(json, 'count') ? undefined : json['count'],
    };
}
exports.HistoricalEventFromJSONTyped = HistoricalEventFromJSONTyped;
function HistoricalEventToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'type': (0, EventType_1.EventTypeToJSON)(value.type),
    };
}
exports.HistoricalEventToJSON = HistoricalEventToJSON;
